<mat-card class="sign-flow-anonymous" style="padding: 1rem !important; touch-action: auto !important;">
  <mat-card-header>
      <mat-card-title id="title-sign" style="padding-bottom: 0.75rem; border-bottom: 1px solid #0000001f;"><span *ngIf="!isSignDigitalCertificate">{{ "title.signing_document" | translate }}</span>
          <span *ngIf="isSignDigitalCertificate">{{ "title.approving_document" | translate }}</span>
          <span *ngIf="document">{{document.code}} - {{document.name}}</span>
      </mat-card-title>
  </mat-card-header>

  <mat-card-content class="mat-card-content-contract-sm bg-white p-3">
      <mat-accordion #accordion="matAccordion" [multi]="true">
          <div id="sign-flow-document-v2" class="css-container">
              <div class="row">
                  <div [ngClass]="{ 'col-lg-6 ': !isFullviewPdf }" [hidden]="isFullviewPdf"
                      class="col-md-12 col-sm-12 pr-0">
                      <div #focus tabindex="-1" class="pr-4 css-info-sign">
                          <!-- Select sign method -->
                          <div style="border-color: #F2F2F2;"
                              class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                              <div class="text-base font-bold">{{ 'sign_flow_document.sign_method' | translate }}
                              </div>
                          </div>
                          <div>
                              <div class="font-bold py-3">{{'title.select_sign_method' | translate}}</div>
                              <!--    tab chọn phương thức ký-->
                              <mat-radio-group [(ngModel)]="typeCertificate" (change)="onChangeSelectCertificateType($event.value)"
                              [ngModelOptions]="{ standalone: true }" class="mb-3 flex radio-group">
                              <mat-radio-button
                                  [value]="enumSignMethod.SIGN_SIM_CA"
                                  class="pr-3">
                                  {{'digital_certificate_management.cbx_certificate_type.cbx_sim_ca'
                                  |
                                  translate}}</mat-radio-button>
                              <mat-radio-button
                                  [value]="enumSignMethod.SIGN_USB_TOKEN"
                                  class="pr-3">
                                  {{'digital_certificate_management.cbx_certificate_type.cbx_usb'
                                  |
                                  translate}}</mat-radio-button>
                              <mat-radio-button
                                  [value]="enumSignMethod.CLOUD_CA"
                                  class="pr-3">
                                  {{'digital_certificate_management.cbx_certificate_type.cbx_cloud_ca'
                                  |
                                  translate}}</mat-radio-button>
                                <mat-radio-button *ngIf="allowOtp && (isPersonal || (!isPersonal && entTypeAnonymus == 2 && !isBuyService && !(isSignDigitalCertificate && !isShowImage)))"
                                  [value]="enumSignMethod.SIGN_OTP"
                                  class="pr-3">
                                  {{'digital_certificate_management.cbx_certificate_type.cbx_otp_2' | translate}} {{ (supportEkyc && isPersonal) ? ( "digital_certificate_management.rd_certificate_type.ekyc_support" | translate) : '' }}
                              </mat-radio-button>
                              <mat-radio-button *ngIf="entTypeAnonymus == 2 && isSignVNeID"
                                  [value]="enumSignMethod.VNEID"
                                  class="pr-3">
                                  {{'digital_certificate_management.cbx_certificate_type.cbx_vneid' | translate}}
                              </mat-radio-button>
                          </mat-radio-group>
                          <div class="ds-cts">
                                        <!-- *********_SimCA_********* -->
            <!-- số điện thoại -->
            <div class="row"  *ngIf="typeCertificate == enumSignMethod.SIGN_SIM_CA">
              <div class="col-lg-4 col-sm-6 mt-3">
                <mat-form-field class="w-100">
                  <span matPrefix>+84 &nbsp;</span>
                  <input matInput (focusout)="simCaPhoneNumber=simCaPhoneNumber.trim()" type="text"
                    placeholder="{{'digital_certificate_management.lbl_phone' | translate}}" [pattern]="otpPhoneNumberPattern"
                    [(ngModel)]="simCaPhoneNumber" name="phoneNumber" #phoneNumber="ngModel" [maxlength]="maxLengthPhone" required>
                  <button mat-button *ngIf="simCaPhoneNumber" matSuffix mat-icon-button aria-label="Clear"
                    (click)="simCaPhoneNumber=null">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="phoneNumber.invalid">
                    <span class="text-error" *ngIf="phoneNumber?.errors?.required">
                      {{'validation.phone_number_re' | translate}}
                    </span>
                    <span class="text-error" *ngIf="phoneNumber?.errors?.pattern">
                      {{'validation.phone_format_upgrade' | translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-8 col-sm-6 d-flex justify-content-start align-items-center mb-2">
                <button mat-raised-button type="button" [disabled]="!simCaPhoneNumber" (click)="getCertificateOfSimCA()"
                  color="primary">
                  <mat-icon class="mr-0">list</mat-icon>
                  {{'button.get_list' | translate}}
                </button>
              </div>
            </div>
            <!-- danh sách CTS-->
            <div class="row" style="margin-left: 0;">
              <div class="col-12" style="padding-left: 0; padding-right: 0;" *ngIf="typeCertificate == enumSignMethod.SIGN_SIM_CA && listOfDataSimCa.length > 0">
                <nz-table [nzData]="listOfDataSimCa" #dynamicTable nzShowPagination="false" nzBordered="true">
                  <thead>
                    <tr>
                      <th></th>
                      <th class="font-weight-bold" style="max-width: 25%; width: 25%;">{{'enterprise-certificate_management.table_headers.cer_name' | translate}}</th>
                      <th class="desktop font-weight-bold" style="max-width: 10%; width: 10%;">{{'enterprise-certificate_management.table_headers.serial_number' | translate}}</th>
                      <th class="font-weight-bold">{{'digital_certificate_management.mst_cccd_tk_sdt' | translate}}</th>
                      <th class="font-weight-bold">{{'enterprise-certificate_management.table_headers.expiry_date' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-template ngFor let-data [ngForOf]="dynamicTable.data">
                      <tr>
                        <td nzShowCheckbox [(nzChecked)]="data.checked" (nzCheckedChange)="onSelectedSimCaCert($event,data)">
                        </td>
                        <td style="max-width: 25%; width: 25%;">{{data.certificateName}}</td>
                        <td style="max-width: 10%; width: 10%;" class="desktop">{{data.serialNumber}}</td>
                        <td>{{data.taxCode}}</td>
                        <td>{{data.expireDate | dateformat}}</td>
                      </tr>
                    </ng-template>

                  </tbody>
                </nz-table>
              </div>
            </div>
            <!--*************** end SimCa **************-->
                        <!-- *******_USB-Token_******* -->
            <!-- cách tải lên-->
            <div class="row">
              <div class="col-lg-8 col-sm-12">
                <div class="mb-2" style="top: 2rem;" *ngIf="typeCertificate == enumSignMethod.SIGN_USB_TOKEN">
                  <!-- tải lên từ Usb-Token -->
                  <ng-container *ngIf="typeCertificate == enumSignMethod.SIGN_USB_TOKEN" #uploadFromUsb>
                    <div class="mb-3">
                      <button mat-stroked-button color="primary" (click)="onGetCertificate()" type="button">
                        <mat-icon class="mr-0">usb</mat-icon>
                        {{'digital_certificate_management.upload_usb_token' | translate}}
                      </button>
                    </div>

                    <mat-error>
                      <span class="text-error" *ngIf="errorStatus != null">
                        <ng-container *ngIf="errorStatus != 'messages.not_initPlugin'; else errorInitPlugin">
                          {{ errorStatus | translate}}
                        </ng-container>
                        <ng-template #errorInitPlugin>
                          <!-- <ng-container>
                            {{ 'messages.not_initPlugin' | translate}}
                          </ng-container> -->
                          <!-- <br> -->
                          <ng-container>
                            {{ 'messages.check_input_software' | translate}}
                            <a target="_blank" href="{{getLinkDownload('WINDOWS')}}">
                              <span style="cursor: pointer;">{{ 'messages.win' |
                                translate}} </span>
                            </a>
                            <a target="_blank" href="{{getLinkDownload('MACOS')}}">
                              <span style="cursor: pointer;">{{ 'messages.mac' |
                                translate}} </span>
                            </a>
                            <a target="_blank" href="{{getLinkDownload('LINUX')}}">
                              <span style="cursor: pointer;">{{ 'messages.linux' |
                                translate}} </span>
                            </a>

                          </ng-container>
                          <ng-container>
                            {{ 'messages.check_input_usbtoken' | translate}}
                          </ng-container>
                          <br>
                        </ng-template>
                      </span>
                    </mat-error>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="typeCertificate === enumSignMethod.SIGN_USB_TOKEN && this.usbTokenCertificate.issuedTo">
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text" placeholder="{{'digital_certificate_management.public_by' | translate}}"
                    [value]="usbTokenCertificate.issuedBy" id="cert_Issuer" readonly>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text"
                    placeholder="{{'digital_certificate_management.cer_subject_name' | translate}}"
                    [value]="usbTokenCertificate.issuedTo" id="cert_CN" readonly>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text"
                    placeholder="{{'digital_certificate_management.serial_number' | translate}}"
                    [value]="usbTokenCertificate.serialNumber" id="cert_SNB" readonly>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text" placeholder="{{'digital_certificate_management.mst_cmnd' | translate}}"
                    [value]="usbTokenCertificate.taxCode" id="taxcode" readonly>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text" placeholder="{{'digital_certificate_management.start_date' | translate}}"
                    [value]="usbTokenCertificate.activeDate | date: 'dd/MM/yyyy'" id="cert_ValidFrom" readonly>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text" placeholder="{{'digital_certificate_management.end_date' | translate}}"
                    [value]="usbTokenCertificate.expireDate | date: 'dd/MM/yyyy'" id="cert_ValidTo" readonly>
                </mat-form-field>
              </div>
              <div class="col-6 d-none">
                <mat-form-field class="w-100">
                  <input matInput type="text" placeholder="Raw Data" [value]="usbTokenCertificate.certRawdata"
                    id="cert_rawData" readonly>
                </mat-form-field>
              </div>
            </div>
            <!-- ********** end Usb Token ************-->

                        <!-- ********* OTP ********* -->
                        <div class="row" *ngIf="typeCertificate == enumSignMethod.SIGN_OTP && allowOtp && (isPersonal || (!isPersonal && entTypeAnonymus == 2 && !isBuyService && !(isSignDigitalCertificate && !isShowImage)))">
                          <div class="col-lg-4 col-sm-6 mt-3">
                            <mat-form-field class="w-100">
                              <span matPrefix>+84 &nbsp;</span>
                              <input matInput (focusout)="otpPhoneNumber=otpPhoneNumber.trim()" type="text"
                                placeholder="{{'digital_certificate_management.phone_number' | translate}}"
                                [(ngModel)]="otpPhoneNumber" name="otpPhone" #otpPhone="ngModel"
                                [maxlength]="otpPhoneNumberMaxLength" required [pattern]="otpPhoneNumberPattern"
                                (ngModelChange)="changePhone($event)">
                              <button mat-button *ngIf="otpPhoneNumber" matSuffix mat-icon-button aria-label="Clear"
                                (click)="clear()">
                                <mat-icon>close</mat-icon>
                              </button>
                              <mat-error *ngIf="otpPhone.invalid">
                                <span class="text-error" *ngIf="otpPhone?.errors?.required">
                                  {{'validation.phone_number_re' | translate}}
                                </span>
                                <span class="text-error" *ngIf="otpPhone?.errors?.pattern">
                                  {{'validation.phone_format_upgrade' | translate}}
                                </span>
                                <span class="text-error" *ngIf="otpPhone?.errors?.maxlength">
                                  {{'lading_page.main.contact.validate_form.phone_otp_max_length' | translate}}
                                </span>
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <!-- ********** end OTP ************-->

                        <!-- ********* Ký ảnh ********* -->
                        <div class="container"
                          *ngIf="typeCertificate === enumSignMethod.SIGN_NO_CERT && signDataValidate.allowImage && ((signPosition && signPosition.length > 0 && signPosition[0].signType !== signPositionTypes.DIGITAL) || (signPosition && signPosition.length === 0))">
                          <mat-radio-button class="example-radio-button" checked="true">
                          </mat-radio-button>
                          {{'enterprise_contract.image_signing.new_tab.no_select_method_detail' | translate}}<br />
                          <span
                            class="registered-tab-title-note">{{'enterprise_contract.image_signing.new_tab.no_select_method_AN_detail'
                            | translate}}</span>
                        </div>
                        <!-- ********** end Ký ảnh ************-->
                                     <!--            CLOUD CA-->
              <div class="row" *ngIf="typeCertificate == enumSignMethod.CLOUD_CA">
                <div class="col-lg-4 col-sm-6 mt-3">
                  <div>
                    <mat-form-field>
                      <mat-label>{{'digital_certificate_management.lbl_provider_cloudca' | translate}}</mat-label>
                      <mat-select #providerSelect id="providerSelect"
                        [(ngModel)]="providerName"
                        #provider="ngModel" required name="providerSelect">
                        <mat-option *ngFor="let item of lstCloudCaProvider" [value]="item.name"
                          (click)="this.commonService.closeDropdownList(this.providerSelect)">
                          {{item.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-lg-4 col-sm-6 mt-3" *ngIf="typeCertificate == enumSignMethod.CLOUD_CA">
                  <mat-form-field class="w-100">
                    <input matInput type="text"
                      placeholder="{{'digital_certificate_management.lbl_account_cloudca' | translate}}"
                      (focusout)="cloudCaUsername = cloudCaUsername.trim()" [(ngModel)]="cloudCaUsername"
                      name="cloudCaUsername" #cloudCaUserId="ngModel" [ngClass]="{ 'is-invalid': cloudCaUserId.invalid }"
                      maxlength="50" required>
                    <button mat-button *ngIf="cloudCaUsername" type="button" matSuffix mat-icon-button aria-label="Clear"
                      (click)="cloudCaUsername=''">
                      <mat-icon>close</mat-icon>
                    </button>
                    <mat-error *ngIf="cloudCaUserId.invalid">
                      <span class="text-error" *ngIf="cloudCaUserId?.errors?.required">
                        {{'validation.account_cloudca_required' | translate}}
                      </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-4 col-sm-6 d-flex justify-content-start align-items-center mb-2"
                  *ngIf="typeCertificate == enumSignMethod.CLOUD_CA">
                  <button mat-raised-button type="button" [disabled]="!cloudCaUsername || !providerName "
                    (click)="getCertificateCloudCa()" color="primary">
                    <mat-icon class="mr-0">list</mat-icon>
                    {{'button.get_list' | translate}}
                  </button>
                </div>
              </div>

            <!--             danh sách CTS-->
            <div class="col-12" style="padding-left: 0; padding-right: 0;"
              *ngIf="typeCertificate == enumSignMethod.CLOUD_CA && cloudCaDataSource.length > 0">
              <nz-table [nzData]="cloudCaDataSource" #dynamicTable2 nzShowPagination="false" nzBordered="true">
                <thead>
                  <tr>
                    <th></th>
                    <th class="font-weight-bold" style=" max-width: 25%; width: 25%;">{{'enterprise-certificate_management.table_headers.cer_name' | translate}}</th>
                    <th class="font-weight-bold desktop" style=" max-width: 10%; width: 10%;">{{'enterprise-certificate_management.table_headers.serial_number' | translate}}</th>
                    <th class="font-weight-bold">{{'digital_certificate_management.mst_cccd_tk_sdt' | translate}}</th>
                    <th class="font-weight-bold">{{'enterprise-certificate_management.table_headers.expiry_date' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-template ngFor let-data [ngForOf]="dynamicTable2.data">
                    <tr>
                      <td nzShowCheckbox [(nzChecked)]="data.checked" (nzCheckedChange)="onSelectedCloudCaCert($event,data)">
                      </td>
                      <td style=" max-width: 25%; width: 25%;">{{data.certificateName}}</td>
                      <td class="desktop" style=" max-width: 10%; width: 10%;">{{data.serialNumber}}</td>
                      <td>{{data.taxCode}}</td>
                      <td>{{data.expireDate | dateformat}}</td>
                    </tr>
                  </ng-template>

                </tbody>
              </nz-table>
            </div>
            <!--            ******** END CLOUD CA *********-->
            <!-- VNeID -->
            <div class="row" *ngIf="typeCertificate == enumSignMethod.VNEID">
              <div class="col-lg-4 col-sm-6 mt-3" *ngIf="typeCertificate == enumSignMethod.VNEID">
                <mat-form-field class="w-100">
                  <input matInput type="text"
                    placeholder="{{'digital_certificate_management.lbl_account_vneid' | translate}}"
                    [(ngModel)]="VNeIDDataUser" (keydown)="blockNonNumber($event)"
                    (paste)="blockNonNumberPaste($event)"
                    name="VNeIDDataUser" #VNeIDUserId="ngModel" [ngClass]="{ 'is-invalid': VNeIDUserId.invalid }"
                    maxlength="200" required (input)="onNumberInput()">
                  <button mat-button *ngIf="VNeIDDataUser" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="VNeIDDataUser=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="VNeIDUserId.invalid">
                    <span class="text-error" *ngIf="VNeIDUserId?.errors?.required">
                      {{'validation.account_vneid_required' | translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-8 col-sm-6 d-flex justify-content-start align-items-center mb-2"
                *ngIf="typeCertificate == enumSignMethod.VNEID">
                <button mat-raised-button type="button" [disabled]="!VNeIDDataUser || VNeIDDataUser.length < 12 || disableGetCertifcate"
                  (click)="getCertificateVNeID()" color="primary">
                  <mat-icon class="mr-0">list</mat-icon>
                  {{'button.get_list' | translate}}
                </button>
              </div>
            </div>
            <div class="col-12" class="table-rps"
              *ngIf="typeCertificate == enumSignMethod.VNEID && VNeIDDataSource.length > 0">
              <nz-table [nzData]="VNeIDDataSource" #dynamicTable3 nzShowPagination="false" nzBordered="true" [nzShowPagination]="false" [nzFrontPagination]="false">
                <thead>
                  <tr>
                    <th></th>
                    <th class="font-weight-bold desktop">{{'enterprise-certificate_management.table_headers.no' | translate}}</th>
                    <th class="font-weight-bold desktop">{{'digital_certificate_management.lbl_provider_cloudca' | translate}}</th>
                    <th class="font-weight-bold">{{'enterprise-certificate_management.table_headers.cer_name' | translate}}</th>
                    <th class="font-weight-bold desktop">{{'enterprise-certificate_management.table_headers.serial_number' | translate}}</th>
                    <th class="font-weight-bold">{{'enterprise-certificate_management.table_headers.tax_code_cmtnd' | translate}}</th>
                    <th class="font-weight-bold desktop">{{'enterprise-certificate_management.table_headers.effective_date' | translate}}</th>
                    <th class="font-weight-bold">{{'enterprise-certificate_management.table_headers.expiry_date' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-template ngFor let-data [ngForOf]="dynamicTable3.data">
                    <tr>
                      <td nzShowCheckbox [(nzChecked)]="data.checked" (nzCheckedChange)="onSelectedVNeIDCert($event,data)">
                      </td>
                      <td class="text-center desktop">{{data.STT}}</td>
                      <td class="desktop">{{data.issuerDN}}</td>
                      <td class="">{{data.certificateName}}</td>
                      <td class="desktop"><div class="text-truncate" style="max-width: 120px;" [matTooltip]="data.serialNumber">{{data.serialNumber}}</div></td>
                      <td class=""><div class="text-truncate" style="max-width: 120px;" [matTooltip]="data.identifier">{{data.identifier}}</div></td>
                      <td class="desktop">{{data.validFrom}}</td>
                      <td class="">{{data.validTo}}</td>
                    </tr>
                  </ng-template>

                </tbody>
              </nz-table>
            </div>
            <!-- End VNeID -->
                                                            <!-- Tôi đã đọc, hiểu rõ, đồng ý và cam kết tuân thủ các Điều khoản -->
            <div class="row mt-3">
              <div class="col-12">
                <mat-checkbox [(ngModel)]="checkAgree" [ngModelOptions]="{standalone: true}" color="primary"></mat-checkbox>
                <span style="font-size:14px; margin-left: 0.25rem;"> {{'form.i_have_read' | translate}} <a tabindex="0"
                    routerLink="/registration-terms-information-sign-anonymous" target="_blank"> {{'form.rule' |
                    translate}} </a>
                </span>
              </div>
            </div>
                          </div>
                              <!--    end tab chọn phương thức ký-->
                          </div>

                          <!-- Select image signature -->
                          <ng-container
                              *ngIf="(isSignDigitalCertificate && isShowImage) || !isSignDigitalCertificate">
                              <div style="border-color: #F2F2F2;"
                                  class="d-flex justify-content-between align-items-center pb-2 border-bottom mt-4">
                                  <div class="text-base font-bold">{{
                                      'enterprise_contract.image_signing.title_step_2'
                                      | translate }}
                                  </div>
                              </div>

                              <div>
                                  <nz-tabset class="mt-3" [nzTabPosition]="'top'" [nzType]="'card'"
                                      [(nzSelectedIndex)]="indexSelect"
                                      (nzSelectChange)="nzSelectChange($event.index)">

                                      <!-- Tab ảnh mặc định hệ thống -->
                                      <nz-tab *ngIf="isDisplaySignatureTab(1)"
                                          [nzTitle]="'enterprise_contract.image_signing.new_tab.system_image' | translate">
                                          <div class="tab-content">
                                              <app-image-sign-config [selectedCert]="selectedCert" [isHiddenLabel]="isCustomer"
                                                  [enterpriseName]="enterpriseName" [signConfig]="signConfig"
                                                  [domRenderImage]="SignImageConfig" [signMethod]="enumSignMethod"
                                                  [scopeType]="scopeType"
                                                  [defaultImageConfigs]="defaultImageConfigs" [isSetUpConfig]="isSetUpConfig"
                                                  (eventIsSetUpConfig)="isSetUpConfig = true"
                                                  (eventConfirmChangeSignatureImage)="convertHtmlToImage()">
                                                  <ng-container *ngTemplateOutlet="ImageConfigView">
                                                  </ng-container>
                                              </app-image-sign-config>
                                          </div>
                                      </nz-tab>

                                      <!-- tab ảnh ký -->
                                      <nz-tab [nzTitle]="uploadImage" *ngIf="
                                    (!onlyDigital ||
                                    selectedCert.typeCertificate === enumSignMethod.SIGN_NO_CERT) && isDisplaySignatureTab(2)
                                  ">
                                          <ng-template #uploadImage>{{
                                              "enterprise_contract.image_signing.new_tab.image_signature"
                                              | translate
                                              }}
                                          </ng-template>
                                          <div class="tab-content">
                                              <div class="row">
                                                  <div
                                                      class="clearfix nz-upload-clearfix d-flex justify-content-center">
                                                      <nz-upload [nzAccept]="'image/jpeg,image/jpg,image/png'"
                                                          [nzPreview]="handlePreview"
                                                          class="avatar-uploader px-3 pt-3"
                                                          [nzCustomRequest]="dummyRequest" nzName="avatar"
                                                          nzListType="picture-card" [nzShowUploadList]="false"
                                                          [nzBeforeUpload]="beforeUpload"
                                                          (nzChange)="handleChange($event)">
                                                          <ng-container
                                                              *ngIf="!avatarUrl && !selectedCert.imageUrl">
                                                              <i class="upload-icon" nz-icon
                                                                  [nzType]="loading ? 'loading' : 'plus'"></i>
                                                              <div class="ant-upload-text">
                                                                  {{ "form.select_upload" | translate }}
                                                              </div>
                                                          </ng-container>
                                                          <img *ngIf="avatarUrl || selectedCert.imageUrl"
                                                              [src]="sanitize(avatarUrl ? avatarUrl : selectedCert.imageUrl)"
                                                              style="max-height: 300px; max-width: 600px" />
                                                      </nz-upload>
                                                  </div>
                                              </div>

                                              <ng-container *ngIf="avatarUrl;else noteUploadImage">
                                                  <div class="d-flex justify-content-center mt-1">
                                                      <div class="btn-upload-signature">
                                                          <nz-upload [nzAccept]="'image/jpeg,image/jpg,image/png'"
                                                              [nzPreview]="handlePreview" class="px-3"
                                                              [nzCustomRequest]="dummyRequest" nzName="avatar"
                                                              nzListType="picture-card" [nzShowUploadList]="false"
                                                              [nzBeforeUpload]="beforeUpload"
                                                              (nzChange)="handleChange($event)">
                                                              <svg width="17" height="17" viewBox="0 0 17 17"
                                                                  fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                  <path
                                                                      d="M14.15 2.91616C12.7 1.46616 10.71 0.566162 8.50001 0.566162C4.08001 0.566162 0.51001 4.14616 0.51001 8.56616C0.51001 12.9862 4.08001 16.5662 8.50001 16.5662C12.23 16.5662 15.34 14.0162 16.23 10.5662H14.15C13.33 12.8962 11.11 14.5662 8.50001 14.5662C5.19001 14.5662 2.50001 11.8762 2.50001 8.56616C2.50001 5.25616 5.19001 2.56616 8.50001 2.56616C10.16 2.56616 11.64 3.25616 12.72 4.34616L9.50001 7.56616H16.5V0.566162L14.15 2.91616Z"
                                                                      fill="#EE0033" />
                                                              </svg>
                                                              <span class="ml-2"
                                                                  style="color: #EE0033;">{{'button.change_signature_image'
                                                                  | translate}}</span>
                                                          </nz-upload>
                                                      </div>
                                                  </div>
                                                  <div class="guiding-info d-flex justify-content-center mt-1">
                                                      {{ 'messages.note_signature_image' | translate }}
                                                  </div>
                                              </ng-container>
                                              <ng-template #noteUploadImage>
                                                  <div class="d-flex justify-content-center text-center">
                                                      <span class="guiding-info pt-2 pb-3">{{
                                                          "title.upload_image_sign_guiding1" | translate }}
                                                          <br />{{
                                                          "title.upload_image_sign_guiding2" | translate
                                                          }}</span>
                                                  </div>
                                              </ng-template>
                                          </div>
                                      </nz-tab>

                                      <!-- tab vẽ chữ ký desktop -->
                                      <nz-tab [nzTitle]="drawSignature" (nzSelect)="onSelectDrawSign()"
                                          *ngIf="(!onlyDigital || selectedCert.typeCertificate === enumSignMethod.SIGN_NO_CERT) && isDisplaySignatureTab(3)">
                                          <ng-template #drawSignature>{{
                                              "enterprise_contract.image_signing.new_tab.draw_signature"
                                              | translate
                                              }}
                                          </ng-template>

                                          <div class="steps-content">
                                              <div class="tab-content d-flex justify-content-center">
                                                  <app-canvas [canvasWidth]="canvasWidth"
                                                      [isSignflowDocument]="true" [canvasHeight]="canvasHeight">
                                                  </app-canvas>
                                              </div>
                                          </div>
                                      </nz-tab>
                                  </nz-tabset>
                              </div>
                          </ng-container>

                          <!-- Write note -->
                          <ng-container *ngIf="!isSignDigitalCertificate">
                              <div style="border-color: #F2F2F2;"
                                  class="d-flex justify-content-between align-items-center pb-2 border-bottom mt-4">
                                  <div class="text-base font-bold">{{ 'sign_flow_document.note_sign_approval'
                                      | translate }}
                                  </div>
                              </div>
                              <div>
                                  <mat-form-field class="w-100 mt-4">
                                      <mat-label>
                                          {{ 'sign_flow_document.enter_note' | translate }}
                                      </mat-label>
                                      <textarea matInput rows="2" [formControl]="noteControl" maxlength="250" style="min-height: 40px;"
                                          (focusout)="focusoutNoteControl()"></textarea>
                                      <!-- <button mat-button *ngIf="noteControl.value" type="button" matSuffix
                                          mat-icon-button aria-label="Clear" (click)="removeNoteControl()">
                                          <mat-icon>close</mat-icon>
                                      </button> -->
                                  </mat-form-field>
                              </div>
                          </ng-container>
                        <div class="row mt-3" *ngIf="this.showCheckVerifySubject==false  && this.checkPersonalVerify && typeCertificateCheck">
                          <div class="col-12">
                            <mat-checkbox [(ngModel)]="checkVerify"> </mat-checkbox>
                            <span style="font-size:14px; margin-left: 0.25rem;"> {{'form.i_verify_subject' | translate}}</span>
                          </div>
                        </div>
                        <div *ngIf="this.showCheckVerifySubject==false  && this.checkPersonalVerify && !typeCertificateCheck">
                        <mat-checkbox [(ngModel)]="checkVerify"> </mat-checkbox>
                        <span style="font-size:14px; margin-left: 0.25rem;"> {{'form.i_verify_subject' | translate}}</span>
                        </div>
                      </div>
                  </div>
                  <div [ngClass]="{ 'col-lg-6': !isFullviewPdf, 'col-lg-12': isFullviewPdf }"
                      class="col-12 view-pdf pl-3" style="padding-right: 0.75rem;">
                      <div class="parent-document steps-content" class="" [class.landscape]="isViewLandscape">
                          <ng-container
                              *ngIf="document && document.mainContractAttachments && document.mainContractAttachments.length">
                              <div class="document scrollbar_scontract_xs flow-sign-document">
                                  <div class="d-flex">
                                      <div class="py-2 px-3 bg-white d-flex desktop" id="box-left">
                                          <button class="mr-2 ml-2" color="primary" mat-icon-button
                                              (click)="toggleFullviewPdf()">
                                              <mat-icon [hidden]="isFullviewPdf" class="fullview-icon" matTooltip="{{
                                                      'enterprise_contract.tooltips.btn_expand_more' | translate
                                                    }}">
                                                  arrow_back_ios
                                              </mat-icon>
                                              <mat-icon [hidden]="!isFullviewPdf" class="fullview-icon"
                                                  matTooltip="{{
                                                      'enterprise_contract.tooltips.btn_expand_less' | translate
                                                    }}">
                                                  arrow_forward_ios
                                              </mat-icon>
                                          </button>
                                      </div>
                                      <div class="d-flex box-tab" id="box-center" style="width: 100%">
                                          <div class="px-2 py-2 tab d-flex align-items-center"
                                              *ngFor="let file of document.mainContractAttachments; let i = index"
                                              [class.active]="i === activeFile" (click)="changeFile(file.path, i)"
                                              [matTooltip]="file.fileName"
                                              [class.error-tab]="checkFileNotHaveSign(file.id) && i !== activeFile"
                                              [class.border-right]="i !== document.mainContractAttachments.length - 1 && i !== activeFile && i !== activeFile - 1">
                                              <div class="name">
                                                  {{ file.fileName }}
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div>
                                      <ng-container *ngIf="pdfSrc != ''">
                                        <ngx-extended-pdf-viewer [textLayer]="true" [src]="pdfSrc"
                                          (textLayerRendered)="textLayerRendered($event)" [(zoom)]="zoomLevel" [(page)]="pageCurrent"
                                          [showToolbar]="true" useBrowserLocale="true" height="calc(95vh - 180px - 4rem)" [handTool]="false"
                                          [enablePrint]="false" [showDownloadButton]="false" [sidebarVisible]="true"
                                          [showRotateButton]="false" [showOpenFileButton]="false" [showBookmarkButton]="false"
                                          [showPropertiesButton]="true" [showUnverifiedSignatures]="true" [theme]="'dark'"
                                          [language]="language" [zoomLevels]="[0.5,1,1.25, 1.5, 2, 3, 4]"
                                          [showSidebarButton]="isShowSidebarButton">
                                        </ngx-extended-pdf-viewer>
                                      </ng-container>
                                  </div>
                              </div>
                          </ng-container>
                      </div>
                  </div>
              </div>
          </div>

          <!-- Button show desktop, tablet -->
          <div class="scontract-btn-dsk scontract-btn-deskbg-white boder-create-contract text-center mat-elevation-z0 py-2 w-100"
              id="navigation" #navigation
              style="border-top: 1px solid #0000001f; background: white;">
              <button *ngIf="isSignDigitalCertificate" id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button"
                  (click)="backToPrePage(1)">
                  <mat-icon class="mr-0">cancel</mat-icon>
                  {{ "button.cancel" | translate }}
              </button>

              <button *ngIf="!isSignDigitalCertificate" id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button"
                  (click)="backToPrePage()">
                  <mat-icon class="mr-0">cancel</mat-icon>
                  {{ "button.cancel" | translate }}
              </button>

              <button mat-stroked-button color="primary" class="mr-3" (click)="onStamped()"
                  *ngIf="isAllowSelectSignPosition && ((isSignDigitalCertificate && isShowImage) || !isSignDigitalCertificate)">
                  <mat-icon class="mr-0">replay</mat-icon>
                  {{ "enterprise_contract.buttons.re_select_position" | translate }}
              </button>
              <button mat-raised-button color="primary" class="mr-3" (click)="callSignButton(ekycContainer)"
                  [disabled]="checkDisabledBtnSign()">
                  <mat-icon class="mr-0">gesture</mat-icon>
                  <span *ngIf="!isSignDigitalCertificate">{{ "enterprise_contract.buttons.sign" | translate
                      }}</span>
                  <span *ngIf="isSignDigitalCertificate">{{ "enterprise_contract.buttons.approve" | translate
                      }}</span>
              </button>
          </div>

          <!-- Button show mobile -->
          <div class="scontract-btn-mobile bg-white d-flex justify-content-center shadow-lg rounded"
              style="margin-left: -1rem; padding-top: 0.5rem; padding-bottom: 0.5rem; border-top: 1px solid #0000001f; background: white;">
              <div style="display: flex; justify-content: center;">
                <button  *ngIf="isSignDigitalCertificate" style="min-width: 90px !important;" id="btn-cancel" mat-stroked-button color="primary" class="mr-2"
                type="button" (click)="backToPrePage(1)">
                <!-- <mat-icon class="mr-0">cancel</mat-icon> -->
                {{ "button.cancel_2" | translate }}
            </button>

            <button  *ngIf="!isSignDigitalCertificate" style="min-width: 90px !important;" id="btn-cancel" mat-stroked-button color="primary" class="mr-2"
              type="button" (click)="backToPrePage()">
              <!-- <mat-icon class="mr-0">cancel</mat-icon> -->
              {{ "button.cancel_2" | translate }}
          </button>

            <button style="min-width: 90px !important;" mat-stroked-button color="primary" class="mr-2"
                (click)="onStamped()"
                *ngIf="isAllowSelectSignPosition && ((isSignDigitalCertificate && isShowImage) || !isSignDigitalCertificate)">
                <!-- <mat-icon class="mr-0">replay</mat-icon> -->
                {{ "button.re_select_position" | translate }}
            </button>

            <button style="min-width: 90px !important;" mat-raised-button color="primary" class="mr-2"
                (click)="callSignButton(ekycContainer)" [disabled]="checkDisabledBtnSign()">
                <!-- <mat-icon class="mr-0">gesture</mat-icon> -->
                <span *ngIf="!isSignDigitalCertificate">{{ "enterprise_contract.buttons.sign" | translate
                    }}</span>
                <span *ngIf="isSignDigitalCertificate">{{ "enterprise_contract.buttons.approve" | translate
                    }}</span>
            </button>
              </div>
          </div>
      </mat-accordion>
  </mat-card-content>
</mat-card>

<!-- Signature image default -->
<div class="signImageConfig">
  <div #SignImageConfig>
      <ng-container *ngTemplateOutlet="ImageConfigView"></ng-container>
  </div>
</div>

<ng-template #ImageConfigView>
  <ng-container *ngIf="!signConfig?.signatureImage.enabled;else haveSignatureImage">
      <div style="padding: 20px;" [style.width]="'1184px'" [style.height]="'528px'"
          class="image-config_view__content align-items-center d-flex flex-row"
           [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
      </div>
  </ng-container>
  <ng-template #haveSignatureImage>
      <ng-container [ngSwitch]="signConfig?.signaturePosition?.value">
          <div style="padding: 20px;" *ngSwitchCase="'left'" [style.width]="'1464px'" [style.height]="'528px'"
              class="image-config_view__content d-flex align-items-center justify-content-center flex-row">
              <div class="d-flex justify-content-center align-items-center"
                  [style.flex]="getNumber(signConfig.signatureRatio.value)[0]">
                  <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
              </div>
              <div style="padding-left: 24px;" class="d-flex justify-content-start align-items-center"
                   [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)"
                  [style.flex]="getNumber(signConfig.signatureRatio.value)[1]">
                  <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
              </div>
          </div>
          <div style="padding: 20px;" *ngSwitchCase="'right'" [style.width]="'1464px'" [style.height]="'528px'"
              class="image-config_view__content d-flex align-items-center justify-content-center flex-row-reverse">
              <div class="d-flex justify-content-center align-items-center"
                  [style.flex]="getNumber(signConfig.signatureRatio.value)[0]">
                  <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
              </div>
              <div style="padding-left: 24px;" class="d-flex justify-content-start align-items-center"
                   [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)"
                  [style.flex]="getNumber(signConfig.signatureRatio.value)[1]">
                  <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
              </div>
          </div>
          <div style="padding: 20px;" *ngSwitchCase="'top'" [style.width]="'1184px'" [style.height]="'932px'"
              class="image-config_view__content d-flex align-items-center justify-content-center flex-column">
              <div class="d-flex justify-content-center align-items-center"
                  [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 132 * 4 + 'px'">
                  <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
              </div>
              <div class="d-flex justify-content-start align-items-center"
                   [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)"
                  [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 132 * 4 + 'px'">
                  <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
              </div>
          </div>
          <div style="padding: 20px;" *ngSwitchCase="'bottom'" [style.width]="'1184px'" [style.height]="'932px'"
              class="image-config_view__content d-flex align-items-center justify-content-center flex-column-reverse">
              <div class="d-flex justify-content-center align-items-center"
                  [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 132 * 4 + 'px'">
                  <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
              </div>
              <div class="d-flex justify-content-start align-items-center"
                   [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)"
                  [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 132 * 4 + 'px'">
                  <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
              </div>
          </div>
      </ng-container>
  </ng-template>
</ng-template>

<ng-template #SignatureViewContent>
  <ng-container *ngIf="signConfig.signatureImageBase64.value.split(',')[1]">
      <ng-container
          *ngIf="signConfig?.signaturePosition?.value === 'left' || signConfig?.signaturePosition?.value === 'right'">
          <img [style.max-height]="'508px'"
              [style.max-width]="346 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 'px'"
              [src]="signConfig.signatureImageBase64.value">
      </ng-container>
      <ng-container
          *ngIf="signConfig?.signaturePosition?.value === 'top' || signConfig?.signaturePosition?.value === 'bottom'">
          <img [style.max-width]="'1164px'"
              [style.height]="imageSignConfig?.widthImageSignature < 346 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) ? (217 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 28) + 'px' : 'auto'"
              [style.max-height]="(217 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 28) + 'px'"
              [src]="signConfig.signatureImageBase64.value">
      </ng-container>
  </ng-container>
</ng-template>

<ng-template #ImageViewContent>
  <div id="imageConfigContainer" class="imageConfigContainer">
      <ng-container *ngFor="let key of getConfigKeyList()">
          <ng-container *ngTemplateOutlet="ConfigViewItem; context: {$implicit: key}"></ng-container>
      </ng-container>

      <ng-container *ngIf="signConfig.greenTick.enabled">
          <div class="green-tick w-100"
               [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)"
              [style.top]="signConfig.signaturePosition.value ? 18 * 4 * (+getNumber(signConfig.signatureRatio.value)[1] / 100) + 'px' : '72px'"
              >
              <svg width="316" height="232" viewBox="0 0 79 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M77.2308 2.10253C78.9231 3.7948 78.9231 6.53852 77.2308 8.23079L29.5641 55.8975C27.8719 57.5897 25.1281 57.5897 23.4359 55.8975L1.7692 34.2308C0.0769319 32.5385 0.0769319 29.7948 1.7692 28.1025C3.46148 26.4103 6.20519 26.4103 7.89746 28.1025L26.5 46.7051L71.1025 2.10253C72.7948 0.41026 75.5385 0.41026 77.2308 2.10253Z"
                      fill="#52C41A" />
              </svg>
          </div>
      </ng-container>
  </div>
</ng-template>

<ng-template #ConfigViewItem let-data>
  <div [style.font-style]="signConfig.fontStyle.value || ''" [style.font-weight]="signConfig.fontWeight.value || ''"
      [style.fontFamily]="signConfig.fontFamily.value || 'Times-Roman'" *ngIf="showConfig(data)"
      class="view-content-item"
       [style.justify-content]="transformContentPositionValue(signConfig.contentPosition.value)">
      <ng-container *ngIf="data == 'signatureImage' || data == 'isDraw'; else displayColon"></ng-container>
    <ng-template #displayColon>
      <div style="word-break: break-word;" [style.textAlign]="signConfig.contentPosition.value">
        {{signConfig[data].label | translate}}: {{signConfig[data].value}}
      </div>
    </ng-template>

    <!--        <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" class="label"></div>&nbsp;-->

    <!--      <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" align="start" style="word-break: break-word; white-space: pre-wrap;">-->
    <!--        <ng-container>-->
    <!--          {{signConfigClone[data].value}}-->
    <!--        </ng-container>-->
    <!--      </div>-->
  </div>
</ng-template>

<ng-template #ekycContainer>
  <div class="sign-flow-ekyc">
      <app-ekyc-camera [isSignDigitalCertificate]="isSignDigitalCertificate" [isPassport]="isPassport"
          (eventCloseDialog)="onCloseDialog()" (eventSign)="signFlowDocument()"></app-ekyc-camera>
  </div>
</ng-template>

<ng-container *ngIf="isShowWebcam">
  <div style="display: none;">
    <app-ekyc-camera [isSignDigitalCertificate]="isSignDigitalCertificate" [isPassport]="isPassport"></app-ekyc-camera>
  </div>
</ng-container>
